import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Stack,
  CircularProgress,
  IconButton,
  Button,
} from "@mui/material";
import axios from "config/axios";
import { handleAxiosResponseError } from "utils/handleResponseError";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import GoogleButton from "react-google-button";
import { useReactToPrint } from "react-to-print";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { Button as Buton } from "@mui/material";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
// import FacebookIcon from "@mui/icons-material/Facebook";
// import TwitterIcon from "@mui/icons-material/Twitter";
import "./calender.css";
import MyEditor from "components/editor";
import OutlookMailModal from "components/EmailModal/OutlookMailModal";
import { Email } from "@material-ui/icons";
import { useAutosave } from "react-autosave";
import useUserStore from "store/user";
import SendGmailMessageModal from "components/EmailModal/SendGmailMessageModal";
import useGmailStore from "store/gmail";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  borderRadius: "0",
  textAlign: "left",
  color: theme.palette.text.secondary,
}));

const data = [
  {
    color: "#fff8e0",
    detail: "We Should be involved as you produce and deliver your solution",
  },
  {
    color: "#daeaff",
    detail: "We Should be involved as you produce and deliver your solution",
  },
  {
    color: "#ffdff9",
    detail: "We Should be involved as you produce and deliver your solution",
  },
  {
    color: "#dcffea",
    detail: "We Should be involved as you produce and deliver your solution",
  },
  {
    color: "#ffeece",
    detail: "We Should be involved as you produce and deliver your solution",
  },
  {
    color: "#fdc9be",
    detail: "We Should be involved as you produce and deliver your solution",
  },
];
export default function KnowledgeCenter({
  user,
  handleSignOut,
  handleOutlookSignOut,
  isMessageLoad,
  userMessages,
  handleEmail,
  setIsOutlook,
  isOutlook,
  outlookToken,
  outlookMessages,
  outlookLoad,
}) {
  const [yellowNotes, setYellowNotes] = useState(user?.notes);
  const { updateNotes } = useUserStore();
  const [twitter, setTwitter] = useState(user?.twitter);
  const [facebook, setFacebook] = useState(user?.facebook);
  const [social, setSocial] = useState(true);
  const [isChange, setIsChange] = useState(false);
  const [isPrintClick, setIsPrintClick] = React.useState(false);
  const [stickyNum, setStickyNum] = React.useState(8);
  const [showEmailSection, setShowEmailSection] = useState(true);
  const [stickyPrint, setStickPrint] = React.useState([
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const notesRef = useRef();
  const [showOutlookModal, setOutlookShowModal] = useState(false);
  const [selectMessage, setSelectMessage] = useState();
  const [isFirst, setIsFirst] = useState(true);
  const [messageModal, setMessageModal] = useState(false);
  const { googleToken, setLoggedIn } = useGmailStore();

  const handlePrint = () => {
    if (
      isPrintClick &&
      !stickyPrint[0] &&
      !stickyPrint[1] &&
      !stickyPrint[2] &&
      !stickyPrint[3] &&
      !stickyPrint[4] &&
      !stickyPrint[5]
    ) {
      setIsPrintClick(false);
      setStickyNum(8);
    } else {
      setIsPrintClick(true);

      for (let i = 0; i < 6; i++)
        if (stickyPrint[i]) {
          setStickyNum(i);
          break;
        }
    }
  };

  const handleStickyPrint = useReactToPrint({
    content: () => notesRef.current,
    documentTitle: "New Document",
    pageStyle: "print",
  });

  useEffect(() => {
    if (stickyNum !== 8) {
      handleStickyPrint();
      setStickyNum(8);
    }
  }, [stickyNum, handleStickyPrint]);

  const handleStickyClick = (index) => {
    setStickPrint(
      stickyPrint.map((sticky, key) => (key === index ? !sticky : sticky))
    );
  };

  useEffect(() => {
    if (isFirst) {
      setYellowNotes(
        user?.notes?.length ? user.notes : ["", "", "", "", "", ""]
      );
      setIsFirst(false);
    }
    // eslint-disable-next-line
  }, [isFirst]);

  const handleNotes = (value, index) => {
    if (user?.notes && value && value !== yellowNotes[index]) {
      setIsChange(true);
      setYellowNotes(
        yellowNotes?.map((note, key) => {
          return index === key ? value : note;
        })
      );
      // if (delay === 30000) setDelay(3000);
    }
  };

  const handleSignIn = () => {
    // clearToken();
    setLoggedIn(true);
    window.open(`${process.env.REACT_APP_SERVER_URL}/get-code`, "_self");
  };

  const handleOutlookSignIn = () => {
    console.log("Outlook Clicked .....!!!!");
    window.open(`${process.env.REACT_APP_SERVER_URL}/get-login-url`, "_self");
  };

  useEffect(() => {
    setTwitter(user?.twitter);
  }, [user?.twitter]);

  useEffect(() => {
    setFacebook(user?.facebook);
  }, [user?.facebook]);

  useEffect(() => {
    const script = document.createElement("script");

    script.src = "https://platform.twitter.com/widgets.js";
    script.async = true;

    document.body.appendChild(script);
  }, []);

  const handleOutlookEmail = (message) => {
    setSelectMessage(message);
    setOutlookShowModal(true);
  };

  const handleUpdateNotes = (data) => {
    if (isChange)
      axios
        .put(`${process.env.REACT_APP_SERVER_URL}/api/auth/notes/admin`, data)
        .then(({ data }) => {
          setIsChange(false);
          updateNotes(data.admin.notes);
        })
        .catch((err) => {
          console.log(handleAxiosResponseError(err));
        });
  };

  useAutosave({ data: yellowNotes, onSave: handleUpdateNotes });

  const handleMessageModal = () => {
    setMessageModal(!messageModal);
  };

  return (
    <>
      <div>
        <Box
          sx={{
            bgcolor: "#82b7ea",
            padding: 0,
          }}
          className="sticky-header"
        >
          <div className="d-flex justify-content-between p-1">
            <Typography
              variant="body1"
              sx={{ fontWeight: 700, fontSize: "16px", paddingTop: "3px" }}
              color="white"
              className="add-font"
            >
              Sticky Notes
            </Typography>
            <div className="text-white mt-0">
              <Buton
                color="inherit"
                onClick={handlePrint}
                className="pt-0 pb-0 add-font"
              >
                <LocalPrintshopOutlinedIcon
                  className="pt-0"
                  sx={{ fontSize: "1rem", marginRight: "10px" }}
                />
                Print
              </Buton>
            </div>
          </div>
          <div className="social-border">
            <Box className="social-section1 p-1">
              <Typography
                variant="body1"
                sx={{ fontWeight: 700, fontSize: "16px", paddingTop: "3px" }}
                color="white"
              >
                Social Media Feed
              </Typography>
              {/* <Box sx={{ paddingTop: "3px" }}>
                <IconButton
                  className="pt-0 pb-0 text-light"
                  size="small"
                  onClick={() => setSocial(true)}
                >
                  <FacebookIcon fontSize="small" />
                </IconButton>
                <IconButton
                  className="pt-0 pb-0 text-light"
                  size="small"
                  onClick={() => setSocial(false)}
                >
                  <TwitterIcon fontSize="small" />
                </IconButton>
              </Box> */}
            </Box>
          </div>
        </Box>
        <Box className="sticky-section">
          <div className="sticky-div">
            <div
              className="notes-scroll"
              style={{ overflowY: "auto", maxHeight: "100%" }}
            >
              <Box
                sx={{
                  p: 1,
                  bgcolor: "#97c3e6",
                  textAlign: "center",
                }}
              >
                <Stack className="note-row" ref={notesRef}>
                  {data.map((v, index) => (
                    <Box
                      sx={{
                        m: "5px",
                        borderRadius: "8px",
                        bgcolor: `${v.color}`,
                        position: "relative",
                        height: "140px",
                      }}
                      key={index}
                      className={!stickyPrint[index] && "no-print"}
                    >
                      {isPrintClick && (
                        <IconButton
                          className="sticky-print no-print"
                          onClick={() => handleStickyClick(index)}
                        >
                          {stickyPrint[index] ? (
                            <RadioButtonCheckedIcon />
                          ) : (
                            <RadioButtonUncheckedIcon />
                          )}
                        </IconButton>
                      )}

                      <MyEditor
                        note={
                          yellowNotes?.length
                            ? yellowNotes[index]
                            : "Loading..."
                        }
                        user={user}
                        setNote={handleNotes}
                        index={index}
                      />
                    </Box>
                  ))}
                </Stack>
              </Box>
            </div>
          </div>
          <div className="pt-0 mr-0 pr-0 sticky-div">
            <Box className="social-section2">
              <Typography
                variant="body1"
                sx={{ fontWeight: 700, fontSize: "16px" }}
                color="white"
              >
                Social Media Feed
              </Typography>
              {/* <Box>
                <IconButton
                  className="pt-0 pb-0 text-light"
                  size="small"
                  onClick={() => setSocial(true)}
                >
                  <FacebookIcon fontSize="small" />
                </IconButton>
                <IconButton
                  className="pt-0 pb-0 text-light"
                  size="small"
                  onClick={() => setSocial(false)}
                >
                  <TwitterIcon fontSize="small" />
                </IconButton>
              </Box> */}
            </Box>

            <Box
              sx={{
                p: 0,
                bgcolor: "#97c3e6",
                textAlign: "center",
                display: social ? "normal" : "none",
                height: "100%",
              }}
            >
              {/* https%3A%2F%2Fwww.facebook.com%2Ffacebook */}
              <iframe
                src={`https://www.facebook.com/plugins/page.php?href=${
                  user ? facebook : "https%3A%2F%2Fwww.facebook.com%2Ffacebook"
                }&tabs=timeline&width=285&height=317&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`}
                width="285"
                height="317"
                style={{ border: "none" }}
                scrolling="yes"
                frameBorder="0"
                allowFullScreen={true}
                title="facebook"
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              ></iframe>
            </Box>

            {/* <Box
              sx={{
                display: !social ? "normal" : "none",
              }}
              className="twitter-section"
            >
              <a className="twitter-timeline" href={twitter}>
                Show Tweets
              </a>
            </Box> */}
          </div>
        </Box>
      </div>
      <Box className="social_container">
        <Box
          className="d-flex justify-content-between"
          sx={{
            bgcolor: "#82b7ea",
          }}
        >
          <Typography
            variant="body1"
            sx={{ fontWeight: 700, fontSize: "16px" }}
            color="white"
            className="p-2"
          >
            Email Inbox
          </Typography>
          <div className="email-dropdown">
            <IconButton
              className="email-dropdown-btn"
              size="small"
              onClick={() => setShowEmailSection(!showEmailSection)}
            >
              <Email style={{ color: "white" }} />
            </IconButton>
            <div
              className={`email-btns ${
                showEmailSection ? "hide-email" : "show-email"
              }`}
            >
              <div>
                {isOutlook ? (
                  <button
                    className="show-btns"
                    onClick={() => setIsOutlook(false)}
                  >
                    Show Gmail
                  </button>
                ) : (
                  <button
                    className="show-btns"
                    onClick={() => setIsOutlook(true)}
                  >
                    Show Outlook
                  </button>
                )}
              </div>
              {!isOutlook ? (
                <div className="p-0">
                  {!googleToken ? (
                    <GoogleButton
                      onClick={handleSignIn}
                      className="m-auto add-font"
                    />
                  ) : (
                    <GoogleButton
                      label="Sign Out From Google"
                      onClick={handleSignOut}
                      className="m-auto"
                    />
                  )}
                </div>
              ) : (
                <div>
                  {outlookToken ? (
                    <button
                      className="outlook-btn"
                      onClick={handleOutlookSignOut}
                    >
                      Sign Out from Outlook
                    </button>
                  ) : (
                    <button
                      className="outlook-btn"
                      onClick={handleOutlookSignIn}
                    >
                      Sign In with Outlook
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </Box>
        {/* <div className="new-feature">Feature Coming Soon...</div> */}
        {!isOutlook ? (
          <>
            {isMessageLoad ? (
              <Stack spacing={1} sx={{ overflowY: "auto" }}>
                <Button
                  onClick={handleMessageModal}
                  variant="contained"
                  color="primary"
                  size="small"
                >
                  Compose
                </Button>
                {userMessages.map((message, index) => {
                  let subject, from, to;
                  message.headers.forEach((item) => {
                    if (item.name === "Subject") subject = item;
                    if (item.name === "From") from = item;
                    if (item.name === "To") to = item;
                  });
                  return (
                    <Item
                      key={index}
                      onClick={() =>
                        handleEmail({
                          subject: subject.value,
                          From: from.value,
                          To: to.value,
                          body: message.snippet,
                        })
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <div>
                        <Typography sx={{ fontSize: "15px" }}>
                          <span className="font-weight-bold">From : </span>{" "}
                          {from.value}
                        </Typography>
                      </div>
                      <Typography sx={{ fontSize: "12px" }}>
                        {subject.value}
                      </Typography>
                    </Item>
                  );
                })}
              </Stack>
            ) : (
              <div
                className="d-flex justify-content-center"
                style={{
                  minHeight: "400px",
                }}
              >
                {googleToken && <CircularProgress sx={{ color: "#fff" }} />}
              </div>
            )}
          </>
        ) : (
          <>
            {outlookLoad && outlookToken ? (
              <Stack spacing={1} sx={{ overflowY: "auto" }}>
                {outlookMessages.map((message, index) => {
                  return (
                    <Item
                      key={index}
                      onClick={() => handleOutlookEmail(message)}
                      style={{ cursor: "pointer" }}
                    >
                      <div>
                        <Typography sx={{ fontSize: "15px" }}>
                          <span className="font-weight-bold">From : </span>{" "}
                          {message.sender.address}
                        </Typography>
                      </div>
                      <Typography sx={{ fontSize: "12px" }}>
                        {message.subject}
                      </Typography>
                    </Item>
                  );
                })}
              </Stack>
            ) : (
              <div
                className="d-flex justify-content-center"
                style={{
                  minHeight: "400px",
                }}
              >
                {outlookToken && <CircularProgress sx={{ color: "#fff" }} />}
              </div>
            )}
          </>
        )}
        <OutlookMailModal
          open={showOutlookModal}
          setOpen={setOutlookShowModal}
          message={selectMessage}
        />
        <SendGmailMessageModal
          open={messageModal}
          setOpen={setMessageModal}
          googleToken={googleToken}
        />
      </Box>
    </>
  );
}
